import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin    from './AdminLogin';
import AdminLayout   from './AdminLayout';
import Dashboard     from './pages/Dashboard';
import ProductsAdmin from './pages/ProductsAdmin';
import HeroAdmin     from './pages/HeroAdmin';
import NavAdmin      from './pages/NavAdmin';
import DealersAdmin  from './pages/DealersAdmin';
import ResourcesAdmin  from './pages/ResourcesAdmin';
import AdvantagesAdmin from './pages/AdvantagesAdmin';
import SettingsAdmin   from './pages/SettingsAdmin';
import ContactAdmin    from './pages/ContactAdmin';
import FooterAdmin     from './pages/FooterAdmin';
import AboutAdmin      from './pages/AboutAdmin';
import GemAdmin        from './pages/GemAdmin';
import HomeAdmin       from './pages/HomeAdmin';
import OtherProductsAdmin from './pages/OtherProductsAdmin';

const ProtectedRoute = ({ children }) => {
  const ok = sessionStorage.getItem('zinga_admin') === 'yes';
  return ok ? children : <Navigate to='/admin/login' replace />;
};

const AdminApp = () => (
  <Routes>
    <Route path='login' element={<AdminLogin />} />
    <Route
      path='*'
      element={
        <ProtectedRoute>
          <AdminLayout>
            <Routes>
              <Route index         element={<Navigate to='dashboard' replace />} />
              <Route path='dashboard'  element={<Dashboard />} />
              <Route path='products'   element={<ProductsAdmin />} />
              <Route path='hero'       element={<HeroAdmin />} />
              <Route path='navigation' element={<NavAdmin />} />
              <Route path='dealers'    element={<DealersAdmin />} />
              <Route path='resources'  element={<ResourcesAdmin />} />
              <Route path='advantages' element={<AdvantagesAdmin />} />
              <Route path='contact'    element={<ContactAdmin />} />
              <Route path='footer'     element={<FooterAdmin />} />
              <Route path='about'      element={<AboutAdmin />} />
              <Route path='home'          element={<HomeAdmin />} />
              <Route path='other-products' element={<OtherProductsAdmin />} />
              <Route path='gem'            element={<GemAdmin />} />
              <Route path='settings'   element={<SettingsAdmin />} />
            </Routes>
          </AdminLayout>
        </ProtectedRoute>
      }
    />
  </Routes>
);

export default AdminApp;
